var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUsainline = function SvgUsainline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#usa_inline_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#usa_inline_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .5h20v13H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B31942",
    d: "M20 .5H0v13h20z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000008",
    d: "M0 2h20zm20 2H0zM0 6h20zm20 2H0zM0 10h20zm20 2H0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 1.045,
    d: "M0 2h20m0 2H0m0 2h20m0 2H0m0 2h20m0 2H0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0A3161",
    d: "M10.11.5H0v7h10.11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m.842.805.241.723-.63-.447h.779l-.63.447zM.842 2.205l.241.724-.63-.448h.779l-.63.448zM.842 3.604l.241.723-.63-.447h.779l-.63.447zM.842 5.004l.241.724-.63-.448h.779l-.63.448zM.842 6.404l.241.724-.63-.447h.779l-.63.447zM1.685 1.504l.24.724-.63-.448h.78l-.63.448zM1.685 2.904l.24.724-.63-.447h.78l-.63.447zM1.685 4.305l.24.723-.63-.447h.78l-.63.447zM1.685 5.703l.24.724-.63-.447h.78l-.63.447zM2.527.805l.241.723-.63-.447h.779l-.63.447zM2.527 2.205l.241.724-.63-.448h.779l-.63.448zM2.527 3.605l.241.724-.63-.447h.779l-.63.447zM2.527 5.006l.241.723-.63-.447h.779l-.63.447zM2.527 6.404l.241.724-.63-.447h.779l-.63.447zM3.37 1.504l.24.724-.63-.448h.78l-.63.448zM3.37 2.904l.24.724-.63-.447h.78l-.63.447zM3.37 4.305l.24.723-.63-.447h.78l-.63.447zM3.37 5.703l.24.724-.63-.447h.78l-.63.447zM4.213.805l.24.723-.63-.447h.779l-.63.447zM4.213 2.205l.24.724-.63-.448h.779l-.63.448zM4.213 3.605l.24.724-.63-.447h.779l-.63.447zM4.213 5.006l.24.723-.63-.447h.779l-.63.447zM4.213 6.404l.24.724-.63-.447h.779l-.63.447zM5.055 1.504l.24.724-.629-.448h.779l-.63.448zM5.055 2.904l.24.724-.629-.447h.779l-.63.447zM5.055 4.305l.24.723-.629-.447h.779l-.63.447zM5.055 5.703l.24.724-.629-.447h.779l-.63.447zM5.898.805l.24.723-.63-.447h.779l-.63.447zM5.898 2.205l.24.724-.63-.448h.779l-.63.448zM5.898 3.605l.24.724-.63-.447h.779l-.63.447zM5.898 5.006l.24.723-.63-.447h.779l-.63.447zM5.898 6.404l.24.724-.63-.447h.779l-.63.447zM6.74 1.502l.24.724-.63-.448h.78l-.63.448zM6.74 2.902l.24.724-.63-.447h.78l-.63.447zM6.74 4.3l.24.724-.63-.447h.78l-.63.447zM6.74 5.701l.24.724-.63-.447h.78l-.63.447zM7.582.8l.241.724-.63-.447h.779l-.63.447zM7.582 2.201l.241.724-.63-.447h.779l-.63.447zM7.582 3.6l.241.723-.63-.447h.779l-.63.447zM7.582 5l.241.724-.63-.448h.779l-.63.448zM7.582 6.4l.241.724-.63-.447h.779l-.63.447zM8.425 1.502l.24.724-.63-.448h.78l-.63.448zM8.425 2.902l.24.724-.63-.447h.78l-.63.447zM8.425 4.303l.24.723-.63-.447h.78l-.63.447zM8.425 5.703l.24.724-.63-.447h.78l-.63.447zM9.268.8l.24.724-.63-.447h.779l-.63.447zM9.268 2.201l.24.724-.63-.447h.779l-.63.447zM9.268 3.6l.24.723-.63-.447h.779l-.63.447zM9.268 5l.24.724-.63-.448h.779l-.63.448zM9.268 6.4l.24.724-.63-.447h.78l-.63.447z"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#A8B7D4",
    strokeLinejoin: "round",
    strokeWidth: 0.058,
    d: "M0 .5h20v13H0z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "usa_inline_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .5h20v13H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "usa_inline_svg__a",
    width: 22.862,
    height: 15.863,
    x: -1.431,
    y: 0.003,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.935
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.701
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.258824 0 0 0 0 0.278431 0 0 0 0 0.298039 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4575_14408"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.058
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.258824 0 0 0 0 0.278431 0 0 0 0 0.298039 0 0 0 0.32 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_4575_14408",
    result: "effect2_dropShadow_4575_14408"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_4575_14408",
    result: "shape"
  })))));
};
export default SvgUsainline;